import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./components/Header";
import MenuButton from "./components/MenuButton";
import FoodItem from "./components/FoodItem";
import BackToTopButton from "./components/BackToTopButton";
import "./styles/App.scss";
import InfoIcon from "./components/InfoIcon";

const TABS = {
  FOOD: "Food",
  DRINKS: "Drinks"
};

const App = () => {
  const [menuData, setMenuData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [drinksData, setDrinksData] = useState([]);
  const [drinksCategories, setDrinksCategories] = useState([]);
  const [activeTab, setActiveTab] = useState(TABS.FOOD);

  const processCategoriesData = (data, setCategoriesFn) => {
    const categories = data.slice(1).map((item) => item[0]);
    setCategoriesFn(categories);
  };

  const processMenuData = (data, setMenuFn) => {
    const menuItems = data.slice(1).reduce((acc, item) => {
      const [category, subCategory, title, details, weight, price, details_after_price] = item;
      return {
        ...acc,
        [category]: [
          ...(acc[category] || []),
          { title, subCategory, details, weight, price, details_after_price }
        ]
      };
    }, {});
    setMenuFn(menuItems);
  };

  useEffect(() => {
    const spreadsheetId = "1YWOpkShGKsH3zu5vcmfM2K2gGrenVIyOP7RnHqBI_SM";
    const apiKey = "AIzaSyB03uh3XnvPPOJ8DDlYAlgI4jT8WOys-uk";
    const ranges = {
      categories: "categories!A:B",
      menu: "menu!A:G",
      drinksCategories: "drinks_categories!A:B",
      drinks: "drinks!A:G"
    };

    const getSheetData = (range) =>
      axios.get(
        `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${range}?key=${apiKey}`
      );

    const fetchData = async () => {
      try {
        const [
          { data: { values: categoriesValues } },
          { data: { values: menuValues } },
          { data: { values: drinksCategoriesValues } },
          { data: { values: drinksValues } }
        ] = await Promise.all([
          getSheetData(ranges.categories),
          getSheetData(ranges.menu),
          getSheetData(ranges.drinksCategories),
          getSheetData(ranges.drinks)
        ]);

        processCategoriesData(categoriesValues, setCategories);
        processMenuData(menuValues, setMenuData);
        processCategoriesData(drinksCategoriesValues, setDrinksCategories);
        processMenuData(drinksValues, setDrinksData);
      } catch (error) {
        console.error("Error fetching data from Google Sheets", error);
      }
    };

    fetchData();
  }, []);

  // Helper to select correct data based on tab
  const currentCategories = activeTab === TABS.FOOD ? categories : drinksCategories;
  const currentMenuData = activeTab === TABS.FOOD ? menuData : drinksData;

  // Helper to group items by subCategory
  const groupBySubCategory = (items) => {
    const groups = {};
    items.forEach((item) => {
      const key = item.subCategory || "";
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    return groups;
  };

  return (
    <div className="App">
      <Header />
      <div className="menu-tabs">
        <button
          className={`menu-tab${activeTab === TABS.FOOD ? " active" : ""}`}
          onClick={() => setActiveTab(TABS.FOOD)}
        >
          MANCARE
        </button>
        <button
          className={`menu-tab${activeTab === TABS.DRINKS ? " active" : ""}`}
          onClick={() => setActiveTab(TABS.DRINKS)}
        >
          BAUTURI
        </button>
      </div>
      <div className="menu-buttons">
        {currentCategories.map(
          (category) =>
            currentMenuData[category]?.length && (
              <MenuButton key={category} label={category} scrollTo={category} />
            )
        )}
      </div>
      {currentCategories.map(
        (category) =>
          category &&
          currentMenuData[category]?.length && (
            <div className="food-section" id={category} key={category}>
              <h2 className="food-section-category">{category}</h2>
              {Object.entries(groupBySubCategory(currentMenuData[category])).map(
                ([subCategory, items]) => (
                  <React.Fragment key={subCategory || "no-subcategory"}>
                    {subCategory && (
                      <div className="food-section-subcategory">{subCategory}</div>
                    )}
                    {items.map((item, index) => (
                      <FoodItem key={index + subCategory} {...item} />
                    ))}
                  </React.Fragment>
                )
              )}
            </div>
          )
      )}
      <BackToTopButton />
      <InfoIcon />
    </div>
  );
};

export default App;
